import { toQueryString } from '@fiverr-private/futile';

const cleanEmptyValues = (obj) =>
    Object.keys(obj).reduce((acc, key) => {
        const val = obj[key];

        if (val !== undefined && val !== '') {
            return {
                ...acc,
                [key]: obj[key],
            };
        }

        return acc;
    }, {});

export const getUtmParams = ({
    affiliateId,
    utmCampaign,
    afp,
    afp1,
    afp2,
    afp3,
    brand,
    landingPage,
    utmTerm,
    widgetType,
}) =>
    toQueryString(
        cleanEmptyValues({
            bta: affiliateId,
            utm_campaign: utmCampaign,
            utm_term: utmTerm,
            afp,
            afp1,
            afp2,
            afp3,
            brand,
            landingPage,
            afp4: widgetType,
        })
    );
